module.exports = __webpack_public_path__ + "img/ban-account.62e6be92.webp";